require('./FiocProfessionSearchByCategory.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { formatText } = require('core/i18n').i18n;

// @ utilities
const {   
    fiocCurrentProfessionSelectionTagging,
    fiocCurrentProfessionDropdownTagging,
    fiocEconomicActivitySelectionTagging,
    fiocEconomicActivityDropdownTagging, 
} = require('utilities/taggingInfo/fiocTags');

class FiocProfessionSearchByCategory extends React.Component {
    constructor(props) {
        super(props);
       
        this.handleOnChangeSubcategory = this.handleOnChangeSubcategory.bind(this);
        this.handleOnChangeCategory = this.handleOnChangeCategory.bind(this);
    }

    handleOnBlurSubcategory() {
        fiocEconomicActivityDropdownTagging('close')
    }

    handleOnFocusSubcategory() {
        fiocEconomicActivityDropdownTagging('open')
    }

    handleOnChangeSubcategory(event) {
        const { configuration: { handleOnChange } } = this.props;
        fiocEconomicActivitySelectionTagging(event.label)
        handleOnChange(event);
    }

    handleOnBlur() {
        fiocCurrentProfessionDropdownTagging('close')
    }

    handleOnFocus() {
        fiocCurrentProfessionDropdownTagging('open')
    }

    handleOnChangeCategory(event) {
        this.props.onChangeCategory(event);
        fiocCurrentProfessionSelectionTagging(event.label)
    }


    buildSubcategories() {
        const {
            category,
            categoryItems,
            component,
            configuration: {
                error: {
                    professionError
                },
                subcategoryId
            },
        } = this.props;
        const errorMessage = professionError.get('msgError') ? formatText(professionError.get('msgError')) : '';
        return category && (
            <section className="fioc-profession-search-by-category__subcategories">
                <OKSelect
                    placeholder={formatText("contractsView-checkingPayrollProfessionSearchByCategoryPlaceholder")}
                    searchable={true}
                    label={component.searchByCategorySubcategoryLabel}
                    options={categoryItems}
                    onChange={this.handleOnChangeSubcategory}
                    value={subcategoryId}
                    errorState={professionError.get('isErrorVisible')}
                    errorMessage={errorMessage}
                    onBlur={this.handleOnBlurSubcategory}
                    onFocusFunc={this.handleOnFocusSubcategory}
                />
            </section>
        )
    }

    //TODO:We need to implement the error message when we have more information about this
    render() {
        const {
            component,
            configuration: {
                categoryId,
                options,
                error: {
                    categoryError
                }
            },
            onChangeCategory
        } = this.props;
        const subcategories = this.buildSubcategories();
        const errorMessage = categoryError.get('msgError') ? formatText(categoryError.get('msgError')) : '';
        return (
            <div className="fioc-profession-search-by-category">
                <section className="fioc-profession-search-by-category__categories">
                    <OKSelect
                        placeholder={formatText("contractsView-checkingPayrollProfessionSearchByCategoryPlaceholder")}
                        searchable={false}
                        label={component.searchByCategoryLabel}
                        options={options}
                        onChange={this.handleOnChangeCategory}
                        value={categoryId}
                        errorState={categoryError.get('isErrorVisible')}
                        errorMessage={errorMessage}
                        onBlur={this.handleOnBlur}
                        onFocusFunc={this.handleOnFocus}
                    />
                </section>
                {subcategories}
            </div>
        );
    }
}


FiocProfessionSearchByCategory.propTypes = {
    category: PropTypes.string,
    categoryItems: PropTypes.oneOfType([
        PropTypes.array.isRequired,
        PropTypes.object.isRequired,
    ]),
    component: PropTypes.object,
    configuration: PropTypes.object,
    onChangeCategory: PropTypes.func.isRequired
}

module.exports = FiocProfessionSearchByCategory;